<template>
  <div class="">
    <div class="container-fluid">
      <nav class="navbar nav-blue fixed-top">
        <div
          class="row d-flex justify-content-center align-items-center w-100 px-0"
        >
          <div class="col-md-5 text-center logo-area">
            <div class="row">
              <div class="col-md-12">
                <router-link to="" class="no-active">
                  <img
                    src="@/assets/adminlte/images/logo-yellow.svg"
                    class="img-fluid"
                    alt=""
                  />
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-7 d-flex justify-content-end menu-links-area">
            <ul class="header-links">
              <li>
                <a target="_bank" href="https://www.leancoach.com">Home</a>
              </li>
              <li>
                <a target="_bank" href="https://www.leancoach.com/consulting"
                  >Consulting</a
                >
              </li>
              <li>
                <a
                  target="_bank"
                  href="https://www.leancoach.com/LeanManagementSystem"
                  >Lean Management System</a
                >
              </li>
              <li>
                <a target="_bank" href="https://www.leancoach.com/blogs"
                  >Blog</a
                >
              </li>
              <li><a class="active" href="#">Login</a></li>
              <li>
                <a
                  target="_bank"
                  href="https://www.leancoach.com/LeanManagementSystem#registration-sec"
                  >Register</a
                >
              </li>
              <li class="btn-custom">
                <a href="https://www.leancoach.com/contact">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>

    <section class="login-bg">
      <div class="row d-flex justify-content-center">
        <div class="col-md-4">
          <div
            class="mt-250 card"
            style="background-color: #fff; opacity: 100%"
          >
            <div
              class="card-body login-card-body"
              style="border-radius: 0.25rem !important"
            >
              <center>
                <div class="form-row mt-3">
                  <div class="col-md-12 mt-4">
                    <h3 style="color: #062a4c !important;"><b>Login</b></h3>
                  </div>
                  <div class="col-md-12 mb-1">
                    <div class="col-md-4 ">
                      <b><hr style="border: 1px solid "/></b>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12 mt-4 mb-2">
                    <div class="col-md-10">
                      <input
                        type="email"
                        placeholder="Enter your email"
                        v-model="email"
                        class="form-control"
                      />
                      <span class="text-danger mt-1" v-if="errors.email">{{
                        this.errors.email[0]
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12 mt-2 mb-2">
                    <div class="col-md-10">
                      <input
                        v-model="password"
                        type="password"
                        class="form-control"
                        placeholder="Password"
                      />
                      <span class="text-danger mt-1" v-if="errors.password">{{
                        this.errors.password[0]
                      }}</span>
                    </div>
                  </div>
                </div>
                <span class="text-danger">{{ error_msg }}</span>
              </center>
              <div class="row mb-2 ml-5   d-flex align-items-center">
                <div class="col-md-6">
                  <div class="icheck-primary">
                    <input
                      type="checkbox"
                      style="display: inline !important;"
                      id="remember"
                    />
                    <label for="remember" class="pl-2">Remember Me </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="col-xs-12 col-md-8 d-flex justify-content-end mx-0"
                  >
                    <p class="mb-1">
                      <!-- <router-link to="/register" class="text-center" href=""
                      >Register</router-link
                    > -->
                      <router-link
                        to="/forgot-password"
                        class="text-center"
                        href=""
                        >Forgot Password?</router-link
                      >
                    </p>
                  </div>
                </div>
                <!-- /.col -->

                <!-- /.col -->
              </div>

              <!-- /.social-auth-links -->
              <div class="row d-flex justify-content-between"></div>
              <div class="form-row ml-5">
                <div class="col-6">
                  <button
                    type="submit"
                    class="btn btn-primary-square"
                    @click="login"
                  >
                    <b-spinner
                      style="color: #17375e"
                      v-if="loader"
                      label="Spinning"
                    ></b-spinner>
                    <b v-if="!loader"
                      >Login <i class="fa fa-arrow-right" aria-hidden="true"></i
                    ></b>
                    <!-- <img
                      v-if="!loader"
                      src="@/assets/site/images/login.svg"
                      class="svg-btn1"
                      alt=""
                    /> -->
                  </button>
                </div>
              </div>
              <!-- </center> -->
            </div>
            <!-- /.login-card-body -->
          </div>
        </div>
      </div>
    </section>
    <footer id="footer-new" style="background-color: #062a4c">
      <div class="container">
        <div class="row justify-content-between d-flex">
          <div class="col-md-3">
            <img
              class="logo-footer"
              src="@/assets/adminlte/images/logo-yellow.svg"
              alt=""
            />
            <div class="row social-icons-container">
              <div class="col-md-1 col-2">
                <a href=""
                  ><img src="@/assets/adminlte/images/mdi_facebook.svg" alt=""
                /></a>
              </div>
              <div class="col-md-1 col-2">
                <a href=""
                  ><img src="@/assets/adminlte/images/mdi_linkedin.svg" alt=""
                /></a>
              </div>
              <div class="col-md-1 col-2">
                <a href=""
                  ><img src="@/assets/adminlte/images/youtube.svg" alt=""
                /></a>
              </div>
            </div>
            <div class="row d-flex align-items-center justify-content-center">
              <div class="col-md-6 col-3">
                <img
                  src="@/assets/adminlte/images/sba-certificate.svg"
                  class="img-fluid sba-certificate"
                  alt=""
                />
              </div>
              <div class="col-md-6 col-3">
                <img :src="logo" class="img-fluid sba-certificate" alt="" />
              </div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <h3>About</h3>
            <ul>
              <li>Consulting</li>
              <li>Lean Management System</li>
              <li>Blog</li>
              <li>Contact</li>
              <li>Login</li>
              <li>Register</li>
            </ul>
          </div>
          <div class="col-md-2 col-6">
            <h3>Info</h3>
            <ul>
              <li>Privacy Policy</li>
              <li>Cookies</li>
            </ul>
          </div>
          <div class="col-md-4">
            <h3>Sign up for the Lean Coach® Newsletter</h3>
            <p>
              Receive updates, releases, highlights, and developments to help
              you become a leader in your industry.
            </p>
            <div class="row d-flex align-items-center p-small">
              <div class="col-md-9 col-8">
                <input
                  type="text"
                  class="form-control-footer form-invalid"
                  placeholder="email"
                />
              </div>
              <div class="col-md-3 col-3">
                <a href="#" class="btn btn-primary">Subscribe</a>
              </div>
            </div>
          </div>
        </div>
        <p class="text-center">
          © 2018-2024 Lean Coach. All Rights Reserved.
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "LoginView",
  data() {
    return {
      email: null,
      password: null,
      errors: [],
      error_msg: null,
      loader: false,
    };
  },
  methods: {
    login() {
      //Save or update User Details
      this.errors = [];
      this.error_msg = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/login";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          email: this.email,
          password: this.password,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            var userData = {
              user: data.user,
              role: data.user.role,
              token: data.token,
              status: true,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            if (userData.user.role == "Admin") {
              window.location.href = "admin";
            } else {
              window.location.href = "admin";
            }
          } else if (data.status === false) {
            localStorage.clear();

            this.error_msg = data.message;
          } else {
            this.errors = data.errors;
          }
          this.loader = false;
        })
        .catch(
          function(err) {
            console.log("User Data", "Error : " + err.message, "error");
            this.loader = false;
          }.bind(this)
        );
    },
  },
};
</script>
<style>
.no-active {
  background-color: transparent;
}
</style>
